export const APPLICATION_SOURCE_OPTIONS = [
  "Facebook",
  "Instagram",
  "LinkedIn",
  "Reddit",
  "YouTube",
  "Ads",
  "Google Search",
  "ChatGPT/Gemini/Claude/AI",
  "Onsite Events",
  "Reviews (Career Karma and Course Report)",
  "From a Friend/Family/Alumni",
  "Study International",
  "Others",
] as const;

// Type for source options to ensure type safety
export type ApplicationSource = (typeof APPLICATION_SOURCE_OPTIONS)[number];
